import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';

import ProcessingLoader, { ProcessingLoaderType } from '../../../components/Editor/ProcessingLoader';
import { PdfImportingStatus } from '../constants';
import { getPublicationPdfImportingId, getClientAndResourceIds } from '../utils/helpers';

const mapStateToProps = (state: StoreState) => {
	const {
		editor: {
			combo: { isCombining, percentage: combiningPercentage },
			settings: { pdfImportingStatus },
			preprodPublication: { isUpdating },
		},
		importManager,
	} = state;
	const { tempGId: resourceId } = getClientAndResourceIds();

	let percentage: number | undefined;

	if (isCombining) {
		percentage = combiningPercentage;
	}

	if (pdfImportingStatus === PdfImportingStatus.PROCESSING) {
		const importId = getPublicationPdfImportingId(resourceId, PdfImportingStatus.PROCESSING);
		const importData = importManager.byId[importId];
		percentage = importData ? importData.percentage : 0;
	}

	let type: ProcessingLoaderType;

	if (isCombining) {
		type = ProcessingLoaderType.COMBINING;
	} else if (isUpdating) {
		type = ProcessingLoaderType.PUBLISHING_OR_UPDATING;
	} else {
		type = ProcessingLoaderType.PDF_PROCESSING;
	}

	return {
		type,
		percentage,
	};
};

export default connect(mapStateToProps)(ProcessingLoader);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/ProcessingLoader/index.tsx